import { Box, Skeleton } from "@mui/material";

const AllCardsSkeleton = () => {
  const skeletonCards = Array(8).fill(null);

  return (
    <Box
      sx={{
        width: "80%",
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "20px",
        justifyItems: "left",
        marginLeft: "1%",
      }}
    >
      {skeletonCards.map((_, index) => (
        <Box key={index}>
          <Box sx={{ pt: 0.5 }}>
            <Skeleton />
            <Skeleton width="60%" />
          </Box>
          <Skeleton variant="rectangular" width={250} height={300} />
        </Box>
      ))}
    </Box>
  );
};

export default AllCardsSkeleton;
